// extracted by mini-css-extract-plugin
export var closed = "_gz-1";
export var resizer = "_gz-0";